import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import TabsPermissions from './TabsPermissions';
import CollectionsPermissions from './CollectionsPermissions';
import { Row, Col, Breadcrumb, Tabs, Spin, Typography } from 'antd';
// Tabs
const UserPermissions = props => {
  const { section, id } = useParams();
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState('Collections Permissions');
  const [TabActiveKey, setTabActiveKey] = useState('1');
  const [userData, setUserData] = useState({
    firstName: '',
    lastName: '',
  });

  //Get collection data
  useEffect(() => {
    (async () => {
    try {
      setLoading(true);
      let { data } = await props.getUserData('users', {
        fields: 'role.name,first_name,last_name',
        id,
      });
      if (data.role.name.toLowerCase() === 'administrator') {
        props.history.push('/users');
      }
      setUserData({
        firstName: data.first_name,
        lastName: data.last_name,
      });
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  })();
  }, []);
  // Change Title according to active tab
  let handleTabChange = e => {
    if (e == 2) {
      setTabActiveKey('2');
      setTitle('Other Permissions');
    } else {
      setTabActiveKey('1');
      setTitle('Collections Permissions');
    }
  };
  return (
    <>
      <Spin spinning={loading} size="large">
        <Row>
          <Col className="app-breadcrumb-col">
            <Breadcrumb separator="/" items={[{ title: "Users", href: "/users" }, { title: title }]} />
          </Col>
          <Col className="white-paper">
            <Row gutter={24} className="page-header-section" align="middle">
              <Col xs={24}>
                <Typography.Title level={4} style={{ margin: 0, textTransform: 'capitalize' }}>
                  {id ? `User: ${userData.firstName} ${userData.lastName}` : ''}
                </Typography.Title>
              </Col>
              <Col xs={12} justify="end"></Col>
            </Row>
            <hr />
            <Tabs defaultActiveKey={TabActiveKey} activeKey={TabActiveKey} onChange={handleTabChange} items={[{
  label: "Collections Permissions",
  key: "1",
  children: <CollectionsPermissions {...props} tabActiveKey={TabActiveKey} />
}, {
  label: "Other Permissions",
  key: "2",
  children: <TabsPermissions {...props} handleTabChange={handleTabChange} tabActiveKey={TabActiveKey} />
}]} />
            {/* Tabs End here */}
          </Col>
        </Row>
      </Spin>
    </>
  );
};
export default UserPermissions;
